<div
  class="list-tasks-single-task {{ 'list-tasks-single-task--' + task()?.status }}"
  [ngClass]="{
    'list-tasks-single-task--subtask': isSubtask,
    'list-tasks-single-task--process-group': isProcessGroup(),
    'list-tasks-single-task--subtask-sidenav': simplifiedSubtaskLayout()
  }"
  [dndDraggable]="
    shouldBeDraggable() ? { taskId: task().id, sourceGroupId: groupId(), sourceStatus: status() } : null
  "
  [dndDisableIf]="isProcessGroup() || !shouldBeDraggable()"
  dndType="task"
  dndEffectAllowed="copyMove"
  (dndStart)="dragStart()"
  (dndDrag)="drag($event)"
  (dndEnd)="dragEnd()"
>
  <div class="list-tasks-single-task__container" dndDragImageRef dndHandle>
    @if (!isProcessGroup() && !simplifiedSubtaskLayout()) {
      <div class="drag-handle" [class.hidden]="!shouldBeDraggable()">
        <img draggable="false" width="12" src="./assets/img/ic-sortdragchange.svg" alt="drag-drop" />
      </div>
    }

    <div
      class="list-tasks-single-task__content"
      [ngClass]="'list-tasks-single-task__content--' + task()?.status"
      [class.list-tasks-single-task__content--completed]="isCompleted() || isSentProcessMessageLike()"
    >
      @if (!!parentTask() && !hideHierarchyIndicator()) {
        <div
          class="list-tasks-single-task__content__expander list-tasks-single-task__content__expander--subtask-leading"
          [style.margin-left.px]="subtaskLeadingOffset"
        >
          <mat-icon class="subtask-icon">subdirectory_arrow_right</mat-icon>
        </div>
      }

      <div class="list-tasks-single-task__status-control">
        <button
          type="button"
          class="list-tasks-single-task__content__status-trigger"
          [ngClass]="getTaskTypeCssClass()"
          (click)="onStatusTriggerClick($event)"
        >
          <mat-icon>{{ getTaskTypeIcon() }}</mat-icon>
        </button>

        @if (statusPanelOpen) {
          <div
            class="list-tasks-single-task__status-panel list-tasks-single-task__status-panel--open"
            (click)="$event.stopPropagation()"
          >
            <div class="list-tasks-single-task__status-panel__track">
              @for (option of orderedStatusOptions; track option.id; let first = $first) {
                <button
                  type="button"
                  class="list-tasks-single-task__status-panel__option"
                  [ngClass]="getStatusOptionClasses(option.id, first)"
                  [attr.aria-label]="option.label | translate"
                  [attr.title]="option.label | translate"
                  (click)="onStatusOptionSelected(option.id)"
                >
                  <mat-icon>{{ getTaskStatusIcon(option.id) }}</mat-icon>
                </button>
              }
            </div>
          </div>
        }
      </div>

      <div
        class="list-tasks-single-task__content__assignee"
        [class.list-tasks-single-task__content__assignee--subtask-no-expander]="
          !!parentTask() && !task()?.childrenCount && !hideHierarchyIndicator()
        "
      >
        <avatar-multiple
          [assignSearchDropdownTask]="task()"
          [items]="assignedUsers"
          [width]="24"
          [disabledSearch]="false"
          (onAssignSearchDropdownTaskChange)="onAssignSearchDropdownTaskChange($event)"
        />
      </div>

      @if (!hideHierarchyIndicator() && (task()?.childrenCount || !parentTask())) {
        <div
          class="list-tasks-single-task__content__expander"
          [class.list-tasks-single-task__content__expander--subtask]="!!parentTask()"
        >
          @if (task()?.childrenCount) {
            <expander [opened]="task()?.openedSubtasks" (onClick)="toggleSubtasks()" />
          }
        </div>
      }

      <div
        class="list-tasks-single-task__content__title d-flex {{
          'list-tasks-single-task__content__title--' + task()?.status
        }}"
      >
        <a draggable="false" href="javascript:void(0)" (click)="previewTask($event)">
          {{ task()?.description }}
        </a>

        @if (task()?.hiddenForClient && !simplifiedSubtaskLayout()) {
          <svg-icon
            [title]="'ProjectTasks.Task.hiddenFromClient' | translate"
            class="ml-1"
            src="./assets/img/ic-eye-off.svg"
            [svgStyle]="{ 'width.px': 17, 'height.px': 17 }"
          />
        }
      </div>

      @if (task()?.type && !simplifiedSubtaskLayout()) {
        <div class="list-tasks-single-task__content__type-tag" [ngClass]="getTaskTypeCssClass()">
          {{ getTaskTypeTranslationKey() | translate }}
        </div>
      }

      @if (shouldShowMyWorkProjectMeta && projectMetaInlineLabel) {
        <div class="list-tasks-single-task__content__project-meta-inline">
          {{ projectMetaInlineLabel }}
        </div>
      }

      @if (task()?.childrenCount) {
        <div class="list-tasks-single-task__content__amount cursor-pointer" (click)="toggleSubtasks()">
          <svg-icon [src]="'./assets/img/ic-subtask.svg'" [svgStyle]="{ width: '16px', height: '16px' }" />
          {{ task()?.completedChildrenCount ?? 0 }}/{{ task()?.childrenCount ?? 0 }}
        </div>
      }
    </div>

    <div
      class="list-tasks-single-task__info flex-wrap"
      [class.list-tasks-single-task__info--completed]="isCompleted()"
      [class.list-tasks-single-task__info--completed-like]="isSentProcessMessageLike()"
      [class.list-tasks-single-task__info--cancelled]="task()?.status === 'cancelled'"
      [class.list-tasks-single-task__info--canceled]="task()?.status === 'canceled'"
    >
      @if (task()?.termEnd) {
        @if (showProcessDeadlineTag()) {
          <div class="list-tasks-single-task__info__deadline-tag">
            {{ 'Tasks.deadlineLabel' | translate }}: {{ task()?.termEnd | dateFormat: 'DD.MM.YYYY' }}
          </div>
        } @else {
          <div class="list-tasks-single-task__info__deadline">
            @if (!task()?.termStartTheSameTermEnd) {
              {{ task()?.termStart | dateFormat: 'DD MMM' }} - {{ task()?.termEnd | dateFormat: 'DD MMM' }}
            }

            @if (task()?.termStartTheSameTermEnd) {
              {{ task()?.termEnd | dateFormat: 'DD MMM' }}
            }
          </div>
        }
      }

      @if (shouldShowAnyStatusMeta && !simplifiedSubtaskLayout()) {
        <div class="list-tasks-single-task__info__mail-meta">
          @if (latestTaskMetaActorName || latestTaskMetaActorAvatar) {
            <div class="list-tasks-single-task__info__mail-sender">
              <avatar [imageUrl]="latestTaskMetaActorAvatar" [width]="24" [height]="24" [rounded]="true" />
              <span>{{ latestTaskMetaActorName }}</span>
            </div>
          }

          <div
            class="list-tasks-single-task__info__mail-sent-at"
            [class.list-tasks-single-task__info__mail-sent-at--cancelled]="latestTaskMetaIsCancelled"
          >
            {{ latestTaskMetaLabelKey | translate }}:
            {{ latestTaskMetaDate | dateFormat: 'DD.MM.YYYY - HH:mm' }}
          </div>
        </div>
      }
    </div>

    @if (showRemoveAction() && task()?.id) {
      <button type="button" class="list-tasks-single-task__remove" (click)="emitRemoveTask($event)">
        <svg-icon [src]="'/assets/img/ic-trash-red-v2.svg'" />
      </button>
    }
  </div>
</div>

@if (task()?.openedSubtasks) {
  <div
    class="list-tasks-single-task__subtasks-container"
    [ngClass]="{ 'list-tasks-single-task__subtasks-container--opened': task()?.openedSubtasks }"
  >
    <ng-container *ngFor="let subtask of task()?.children; trackBy: identify">
      <list-tasks-single-task
        *ngIf="!subtask?.deleted"
        [task]="subtask"
        [groupId]="groupId()"
        [isProcessGroup]="isProcessGroup()"
        [status]="childStatus(subtask)"
        [parentTask]="task()"
        [nestingLevel]="nestingLevel() + 1"
        [hideHierarchyIndicator]="hideHierarchyIndicator()"
        (statusUpdated)="statusUpdated.emit($event)"
        (taskClicked)="taskClicked.emit($event)"
      />
    </ng-container>
  </div>
}
